import { useEffect, useMemo, useState } from "react";
import { Controller } from "react-hook-form";
import Creatable from "react-select/creatable";
import * as Sentry from "@sentry/react";
import { api } from "helpers/axios";
import { Select } from "components/ui";
import { useTranslation } from "translation/useTranslation";
import { buildGenderOptions } from "./genderOptions";

export default function GenderSelect({ control, errors = {}, value, acceptedValues = [], name = "gender" }) {
  const { translate } = useTranslation();
  const [storedValues, setStoredValues] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.get("/settings/fields/gender/values")
      .then(({ data, status }) => {
        if (!cancelled && status === 200) setStoredValues(data?.data || []);
      })
      .catch((error) => Sentry.captureException(error));

    return () => { cancelled = true; };
  }, []);

  const options = useMemo(
    () => buildGenderOptions([...acceptedValues, ...storedValues], value, translate),
    [acceptedValues, storedValues, value, translate]
  );

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            as={Creatable}
            {...field}
            options={options}
            error={!!errors?.[name]}
            onChange={(option) => field.onChange(option?.value?.trim() || null)}
            value={options.find((option) => option.value.toLocaleLowerCase() === String(value || "").toLocaleLowerCase()) || null}
            isClearable
            placeholder={translate("form.select_placeholder")}
            noOptionsMessage={() => translate("form.no_options_createable")}
            formatCreateLabel={(input) => `${translate("form.createable_label")} "${input.trim()}"`}
          />
        )}
      />
      {errors?.[name] && <div className="invalid-feedback d-block">{errors[name].message}</div>}
    </>
  );
}
